import React from 'react';
import PropTypes from 'prop-types';
import {HamburgerIcon} from '../../../Icons';
import {ControlButtons, ControlTooltip} from '../../../ControlTooltip';

export function StopperTooltip(props) {
  const tooltipStyle = () => {
    let style = {position: 'absolute', top: '-45px'};
    if (props.selected) {
      style = {top: '-65px'};
    }
    return style;
  };

  return (
    <ControlTooltip
      label='Stopper'
      showControls={props.selected}
      tooltipStyle={tooltipStyle()}>
      <ControlButtons buttonList={props.buttonList} />
    </ControlTooltip>
  );
}

StopperTooltip.propTypes = {
  /**
   * Boolean to set if plant is selected
   */
  selected: PropTypes.bool,
};

StopperTooltip.defaultProps = {
  buttonList: [
    {
      onClick: () => {},
      image: HamburgerIcon,
    },
  ],
};
